import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";

const NAV_ITEMS = [
  { id: "aree", label: "Aree di Attività" },
  { id: "operazioni", label: "Ambiti" },
  { id: "approccio", label: "Approccio" },
  { id: "legaltech", label: "Legal Tech" },
  { id: "contatti", label: "Contatti" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled || !onHome
          ? "backdrop-blur-xl bg-[#0A0A0A]/85 border-b border-[#FAF9F6]/10"
          : "bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <img
            src="/emblem-ricciardi.png"
            alt="Emblema Studio Legale Ricciardi"
            className="h-9 w-auto"
            data-testid="nav-emblem"
          />
          <div className="h-8 w-8 border border-[#C5A880] flex items-center justify-center">
            <span className="font-display text-[13px] font-bold text-[#C5A880]">
              R
            </span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-sm font-semibold tracking-tight">
              Studio Legale Ricciardi
            </div>
            <div className="overline text-[9px]" style={{ letterSpacing: "0.28em" }}>
              Diritto Commerciale · Societario · Immobiliare
            </div>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className="text-[13px] tracking-wide text-[#FAF9F6]/70 hover:text-[#C5A880] transition-colors hover-underline"
              data-testid={`nav-link-${n.id}`}
            >
              {n.label}
            </button>
          ))}
          <Link
            to="/approfondimenti"
            className="text-[13px] tracking-wide text-[#FAF9F6]/70 hover:text-[#C5A880] transition-colors hover-underline"
            data-testid="nav-link-approfondimenti"
          >
            Approfondimenti
          </Link>
        </div>

        <button
          onClick={() => scrollTo("engage")}
          className="hidden md:inline-flex btn-primary px-5 py-2.5 text-[12px] font-semibold tracking-[0.18em] uppercase"
          data-testid="nav-cta-button"
        >
          Prenota un confronto
        </button>
      </nav>
    </motion.header>
  );
}
